import React from 'react'
import { pure } from 'recompose'
import * as Types from 'types'
import ExternalLink from './external-link'

const propTypes = {
  image: Types.image.isRequired,
}

const defaultProps = {}

function CommunityImage({ image, ...rest }) {
  const { src, alt, link } = image
  const Wrapper = link ? ExternalLink : React.Fragment
  const wrapperProps = link ? { href: link } : {}
  const resolvedAlt = typeof alt === 'string' ? alt : ''

  if (process.env.NODE_ENV !== 'production' && !resolvedAlt) {
    // Surface likely missing alt text during development.
    // Decorative images should explicitly pass alt="" at the callsite.
    // eslint-disable-next-line no-console
    console.warn('CommunityImage rendered without alt text:', src)
  }

  return (
    <Wrapper {...wrapperProps}>
      <img src={src} alt={resolvedAlt} {...rest} />
    </Wrapper>
  )
}

CommunityImage.propTypes = propTypes
CommunityImage.defaultProps = defaultProps

export default pure(CommunityImage)
